import React from "react";
import useWebContext from '../../hooks/useWebContext';
import FooterBar from './FooterBar';

/**
 * Footer Component
 */
const Footer = React.memo(() => {

  const screenId = 'MyM902';
  const { controlSettings, screenSettings } = useWebContext(screenId);

  return (
    <footer>
      <FooterBar controlSettings={controlSettings} screenSettings={screenSettings} screenId={screenId} />
    </footer>
  );
})
export default Footer;

